<template>
  <div class="file-viewer">
    <div v-if="file.type === 'image'" class="file-viewer__image">
      <img :src="file.url" :alt="file.name" />
    </div>

    <div v-else-if="file.type === 'video'" class="file-viewer__video">
      <video controls :src="file.url"></video>
    </div>

    <div v-else-if="file.type === 'doc'" class="file-viewer__doc">
      <svg class="icon" width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M26.8035 8.296L24.3795 25H17.9475L16.4595 13L14.8035 25H8.5155L6.1875 8.296H11.1315L12.1875 21.424L13.9635 8.296H19.1235L20.6115 21.424L22.0515 8.296H26.8035Z"
          fill="#2B579A"
        />
        <path d="M1.5 31.5V1.5H31.5V31.5H1.5Z" stroke="#2B579A" stroke-width="3" />
      </svg>
    </div>

    <div v-else-if="file.type === 'pdf'" class="file-viewer__pdf">
      <svg class="icon" width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 31.5V1.5H31.5V31.5H1.5Z" stroke="#E30000" stroke-width="3" />
        <path
          d="M18.4486 14.7397C17.205 15.7354 17.1654 15.7596 16.431 16.3868C15.6967 17.014 15.4226 17.1035 14.1731 18.0923M18.4486 14.7397C22.6951 13.107 23.8297 9.49956 20.8864 8.43992C17.943 7.38027 16.3731 10.9298 18.4486 14.7397ZM18.4486 14.7397C18.7117 16.2779 18.7225 16.2654 18.8943 17.2736C19.0695 18.3012 19.0607 18.4132 19.3329 19.95M14.1731 18.0923C15.6889 18.6333 16.7871 19.0334 16.7871 19.0334C16.7871 19.0334 17.8203 19.4006 19.3329 19.95M14.1731 18.0923C10.584 15.3615 6.77769 16.2174 7.29796 19.2059C7.81822 22.1944 11.7902 21.731 14.1731 18.0923ZM19.3329 19.95C23.8993 20.1552 26.1933 23.2073 23.7703 25.1362C21.3472 27.065 18.6614 24.2047 19.3329 19.95Z"
          stroke="#E30000"
          stroke-width="2"
        />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: ["file"],
};
</script>

<style lang="scss" scoped>
.file-viewer {
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  display: flex;

  &__image, &__video {
    max-width: 100%;
    max-height: 100%;
  }

  img,
  video {
    max-width: 100%;
    max-height: 100%;
  }

  &__doc,
  &__pdf {
    width: 136px;
    height: 102px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 6px;
  }
}
</style>
